<template>
  <form class="create" v-on:submit.prevent="createUser()">
    <input name="username" v-model="username" placeholder="username"/>
    <button type="submit">+</button>
  </form>
</template>

<script>
  import userFunctions from '../../data/userFunctions'
  export default {
    props:['user'],
    data() {
      return {
        username: '',
      }
    },
    methods: {
        createUser () {
            userFunctions.create({
            username: this.username,
            uid: this.user.uid
            }, 
            (err) => {
              if (err) {
                  throw err
              }
                this.username = ''             
              })
        }
    }
  }
</script>


// WEBPACK FOOTER //
// Register.vue?68765750